import { call, put, takeEvery } from "redux-saga/effects";
import { types } from "../action-types";
import { getSearchSuggestionsApi,getKeywordSuggestionsApi,clearRecentSearchApi, getRecentSearchApi, getTrendingJobsApi ,  } from "../../API/API";

function* getSearchSuggestions(action) {
    try {
        const response = yield call(() => getSearchSuggestionsApi(action.payload));
        yield put({ type: types.SEARCH_SUGGESTIONS_SUCCESS, payload: response.data });
        
    } catch (error) {
        yield put({ type: types.SEARCH_SUGGESTIONS_FAILURE, error });
         

        
    }
}

function* getkeywordsSuggestions(action) {
    try {
        const response = yield call(() => getKeywordSuggestionsApi(action.payload)); 
        yield put({ type: types.FETCH_KEYWORDS_SUCCESS, payload: response.data });
    } catch (error) { 
        yield put({ type: types.FETCH_KEYWORDS_FAILURE, error });

        
    }
}


function* getRecentSearches(action) {
    try {
        const response = yield call(() => getRecentSearchApi(action.payload));
        yield put({ type: types.GET_RECENT_SEARCHES_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: types.GET_RECENT_SEARCHES_FAILURE, error });
    }
}


function* clearRecentSearchSaga(action) {
    try {
        const response = yield call(() => clearRecentSearchApi(action.payload));
        yield put({ type: types.CLEAR_RECENT_SEARCH_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: types.CLEAR_RECENT_SEARCH_FAILURE, error });
    }
}



function* getTrendingJobs(action) {
    try {
        const response = yield call(() => getTrendingJobsApi(action.payload));
        yield put({ type: types.GET_TRENDING_JOBS_SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: types.GET_TRENDING_JOBS_FAILURE, error });
    }
}


export function* watchGetSearchSuggestionSaga() {
    yield takeEvery(types.SEARCH_SUGGESTIONS_REQUESTED, getSearchSuggestions);
}

 
export function* watchGetkeywordsSuggestionsSaga() {
    yield takeEvery(types.FETCH_KEYWORDS_INIT, getkeywordsSuggestions);
}


export function* watchGetRecentSearchesSaga() {
    yield takeEvery(types.GET_RECENT_SEARCHES_INIT, getRecentSearches);
}

export function* watchclearRecentSearchSaga() {
    yield takeEvery(types.CLEAR_RECENT_SEARCH_INIT, clearRecentSearchSaga);
}


export function* watchGetTrendingJobsSaga() {
    yield takeEvery(types.GET_TRENDING_JOBS_INIT, getTrendingJobs);
}
